// Enhets-telemetri: batteristatus for teamet. GNÅ/SPARK-enheter melder batteri-
// nivå; SKADE ruller opp lag/tropp så befal ser hvem som er i ferd med å gå tom.
// Ren, testbar logikk (siste-per-enhet vinner + terskel-klassifisering).
import { z } from 'zod';
export const BatteryStatusSchema = z.object({
    unitId: z.string().max(120), // enhet/soldat/sensor-id
    name: z.string().max(200).default(''),
    group: z.string().max(120).default('—'), // lag/tropp for gruppering
    percent: z.number().min(0).max(100),
    charging: z.boolean().default(false),
    tsMs: z.number().default(0),
});
export function parseBatteryStatus(raw) {
    const p = BatteryStatusSchema.safeParse(raw);
    return p.success ? p.data : null;
}
export const BATTERY_LABEL = {
    ok: 'OK', lav: 'Lav', kritisk: 'Kritisk', tom: 'Tom',
};
export const BATTERY_COLOR = {
    ok: '#4bd15b', lav: '#ffd24a', kritisk: '#ff8a3d', tom: '#ff3b3b',
};
/** Terskler: ≥50 ok, 20–49 lav, 5–19 kritisk, <5 tom. */
export function batteryLevel(percent) {
    if (percent >= 50)
        return 'ok';
    if (percent >= 20)
        return 'lav';
    if (percent >= 5)
        return 'kritisk';
    return 'tom';
}
/** Behold nyeste status per enhet (høyeste tsMs vinner). */
export function latestBattery(items) {
    const latest = new Map();
    for (const b of items) {
        const cur = latest.get(b.unitId);
        if (!cur || b.tsMs >= cur.tsMs)
            latest.set(b.unitId, b);
    }
    return [...latest.values()];
}
/** Rull opp batteristatus per gruppe (lag/tropp). Nyeste per enhet først. */
export function rollupBattery(items) {
    const latest = latestBattery(items);
    const byGroup = new Map();
    for (const b of latest) {
        const g = b.group || '—';
        (byGroup.get(g) ?? byGroup.set(g, []).get(g)).push(b);
    }
    const rank = { ok: 0, lav: 1, kritisk: 2, tom: 3 };
    return [...byGroup.entries()].map(([group, list]) => {
        const pcts = list.map((b) => b.percent);
        const min = Math.min(...pcts);
        const avg = Math.round(pcts.reduce((a, b) => a + b, 0) / list.length);
        const critical = list.filter((b) => { const l = batteryLevel(b.percent); return l === 'kritisk' || l === 'tom'; }).length;
        const worst = list.reduce((w, b) => { const l = batteryLevel(b.percent); return rank[l] > rank[w] ? l : w; }, 'ok');
        return { group, count: list.length, avg, min, critical, worst };
    }).sort((a, b) => a.group.localeCompare(b.group));
}
//# sourceMappingURL=telemetry.js.map